export default {
    closed: "Cours en direct fermé",
    do_you_confirm_your_registration_for_the_live_class: "Confirmez-vous votre inscription au cours en direct {title}?",
    do_you_confirm_your_unsubscription_to_the_live_class: "Confirmez-vous votre désinscription au cours en direct {title}?",
    live_class_closed: "Cours en direct fermé",
    live_class_offline: "cours en direct hors ligne",
    live_class_opened: "Cours en direct ouvert",
    live: "Vivre",
    loading_live_classes: "Chargement des cours en direct",
    next: "Prochain",
    no_live_classes_are_available_at_the_moment: "Il n'y a actuellement aucun cours en direct disponible",
    no_live_classes_are_available_with_the_selected_filter: "Aucun cours en direct n'est disponible pour le filtre sélectionné",
    no_vacancy: "Épuisé",
    opened: "Cours en direct ouvert",
    please_wait_the_class_will_start_automatically: "S'il vous plaît, attendez. Vous allez bientôt rejoindre la salle.",
    receive_emails_about_this_live_class: "Recevez des e-mails concernant ce cours en direct",
    register_for_the_live_class: "Inscrivez-vous au cours en direct",
    subscribe: "S'inscrire",
    subscribed: "Inscrit",
    successfully_signed_up_for_the_live_class: "Inscription au cours en direct réussie",
    this_class_has_ended: "Ce cours est terminé",
    transmission_date: "Date de transmission",
    transmission_finished: "Transmission terminée",
    unsubscribe_from_the_live_class: "Se désinscrire du cours en direct",
    unsubscribe_successfully_for_the_live_class: "Se désinscrire avec succès pour le cours en direct",
    unsubscribe: "Se désabonner",
    your_live_class_will_start_soon_please_wait: "Votre cours en direct va bientôt commencer, veuillez patienter",
    this_reaction_assessment_will_only_be_unlocked_after_completing_all_activities_in_this_module: "Cette évaluation de réaction ne sera débloquée qu'après avoir complété toutes les activités de ce module.",
    this_activity_will_only_be_unlocked_after_the_live_class_instructors_authorization: "Cette activité ne sera débloquée qu'après l'autorisation de l'instructeur de la classe en direct."
}